import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueI18n from "vue-i18n";
import de from "./lang/de.json";
import en from "./lang/en.json";
import fr from "./lang/fr.json";
import it from "./lang/it.json";
import "./registerServiceWorker";

Vue.config.productionTip = true;

let lang = "de"; //default language if none is given
let articleNumber = null;
let showLogs = false;
let roomType = false;

const params = location.search.split("?").splice(1, 1); //split at ? and remove first empty array entry

if (params.length) {
  //only if we have params
  const options = params[0].split("&");
  options.forEach(elem => {
    let optionPair = elem.split("=");
    if (optionPair.length == 2) {
      if ("lang" == optionPair[0]) {
        //language is set! @todo maybe check for a valid lang?
        lang = optionPair[1];
      }
      if ("artNr" == optionPair[0]) {
        //articleNumber is set!
        articleNumber = optionPair[1];
      }
      if ("roomType" == optionPair[0]) {
        //articleNumber is set!
        roomType = optionPair[1];
      }
      if ("debug" == optionPair[0]) {
        //debug enabled, show logs!
        showLogs = optionPair[1];
      }
    } else {
      //no key value format, ignore it
    }
  });
}

Vue.use(VueI18n);

//detect language and set it or fall back to "de"
//we currently have de,fr,it,en
const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: "de",
  messages: {
    de: de,
    en: en,
    fr: fr,
    it: it
  }
});

new Vue({
  router,
  store,
  i18n,
  created() {
    this.$store.dispatch("fetchProducts").then(() => {
      showLogs && console.log("Products are loaded (hopefully :) )");
      console.log(process.env.VUE_APP_TITLE);
    });
    if (articleNumber) {
      //if we have a given articleNumber, we store it here into the $store
      this.$store.dispatch("setArticleNumber", articleNumber).then(() => {
        showLogs &&
          console.log(
            "App is starting with a given articleNumber",
            articleNumber
          );
      });
      //we hide the search form, so no change to the articleNumber can be made
      this.$store.dispatch("hideArticleSearch").then(() => {
        showLogs &&
          console.log(
            "setHideArticleSearch to true to hide articleSearch form"
          );
      });
    }
    if (roomType) {
      //if we have a given articleNumber, we store it here into the $store
      this.$store.dispatch("setRoomType", roomType).then(() => {
        showLogs &&
          console.log(
            "App is starting with a given roomType",
            roomType
          );
      });
    }
  },
  render: h => h(App)
}).$mount("#app");
